import React, {useEffect, useRef} from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const AboutUs = ({aboutRef}) => {
    const headingRef = useRef(null);
    const textRef = useRef(null);

    useEffect(() => {
        // Smooth and elegant heading animation

        gsap.fromTo(
            headingRef.current,
            { opacity: 0, y: -50 },
            {
                opacity: 1,
                y: 0,
                duration: 1.5,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: headingRef.current,
                    start: "top 80%",
                    scrub: false,
                    toggleActions: "play reverse play reverse",
                },
            }

        );

        // Staggered fade-up for paragraphs
        const paragraphs = textRef.current.querySelectorAll("p");

        gsap.fromTo(
            paragraphs,
            { opacity: 0, y: 30 },
            {
                opacity: 1,
                y: 0,
                duration: 1.2,
                ease: "power3.out",
                stagger: 0.25,
                scrollTrigger: {
                    trigger: textRef.current,
                    start: "top 80%",
                    end: "bottom 20%",

                    toggleActions: "play reverse play reverse",
                },
            }
        );
    }, []);

    return (
        <div ref={aboutRef}
             className="relative w-full pt-6 pb-10 bg-white flex flex-col items-center justify-center px-6 md:px-12 text-customblue overflow-hidden">
            <img
                src="../images/bg01.png" // replace with your image path
                alt="Decorative Background"
                className="absolute bottom-0 left-0 w-fit md:h-full md:w-auto  opacity-10 pointer-events-none select-none"
            />
            <div className="text-center mb-6">
                <h1
                    ref={headingRef}
                    className="font-montserrat text-4xl sm:text-5xl md:text-6xl font-bold text-[#031c3f]"
                >
                    ABOUT
                </h1>
            </div>

            <div className="w-full text-sm sm:text-base" ref={textRef}>
                <div className="w-full p-6 sm:p-8 md:p-10 space-y-6">
                    <p className="font-roboto text-sm sm:text-base lg:text-lg leading-relaxed text-center">
                        Sun Pledge Holdings is a trusted leader in rooftop solar energy
                        solutions, delivering top-tier installations and unmatched service.
                        With over{" "}
                        <span className="text-yellow-400 font-semibold">150+</span>{" "}
                        completed projects in residential, commercial, and industrial
                        sectors, we have established a reputation for quality and
                        reliability in the renewable energy industry.
                    </p>
                    <p className="font-roboto text-sm sm:text-base lg:text-lg leading-relaxed text-center">
                        Our team consists of{" "}
                        <span className="text-yellow-400 font-semibold">
                            30+ permanent staff members
                        </span>
                        , including two highly experienced electrical engineers who ensure
                        every project is designed with precision and meets the highest
                        standards of safety and performance.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;
